<template>
	<div :style="mainStyle" class="wrapper">
		<el-tabs class="box-card" v-model="activeName" :stretch="true" type="border-card">
			<el-tab-pane label="首次登录,请设置初始密码" name="activePassword" class="tab-panel">
				<el-form class="active-form" :hide-required-asterisk="true"
								 :model="activeForm"
								 :rules="rules"
								 v-loading="loading"
								 ref="activeForm">
					<el-form-item label="请输入密码" prop="password">
						<el-input v-model="activeForm.password" type="password"  placeholder="请输入密码"></el-input>
					</el-form-item>
					<el-form-item label="请再次输入密码" prop="passwordAg">
						<el-input v-model="activeForm.passwordAg" type="password" placeholder="请再次输入密码"></el-input>
					</el-form-item>
					<el-button class="login-btn" type="primary" @click="activePassword('activeForm')">确定</el-button>
				</el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import config from "../../config/global.js";

	var activePasswordUrl = config.host+"/backend/user/addpwd.json";
    export default {
      name: "active-password",
			data:function () {
				var samePasswordValidator = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入密码'));
					} else {
						if (this.activeForm.passwordAg !== '') {
							this.$refs.activeForm.validateField('passwordAg');
						}
						callback();
					}
				};
				var samePasswordValidatorAg = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请再次输入密码'));
					} else if (value !== this.activeForm.password) {
						callback(new Error('两次输入密码不一致!'));
					} else {
						callback();
					}
				};
				return {
					mainStyle:{"width":'100%',"height":window.innerHeight+"px","display":"flex","justify-items":"center","align-items":"center"},
					activeName:"activePassword",
					activeForm: {
						password: "",
						passwordAg:""
					},
					loading: false,
					rules: {
						password: [
							{ validator: samePasswordValidator, trigger: 'blur' }
						],
						passwordAg: [
							{ validator: samePasswordValidatorAg, trigger: 'blur' }
						],
					},
				}
			},
			methods:{
				activePassword:function (formName) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.loading=true;
							var params = {"pwd":this.activeForm.password};
							this.$http.post(activePasswordUrl,params).then(
								function(response){
									var defaultResult = this.responseDefaultHandle(response);
									if(defaultResult == false )
										return;
									var res = response.body;
									if(res.result==1){
										this.$router.replace({"name":"index"});
									}else{
										this.$message.error(res.emsg);
									}
									this.loading=false;
								},function(){
									this.$message.error("设置密码失败");
									this.loading=false;
								})
						} else {
							return false
						}
					})
				}
			}
    }
</script>

<style scoped>
	.wrapper>>>.el-card__body{
		padding: 0px;
	}

	.wrapper>>>.el-form-item__label{
		color: rgb(175, 175, 175);
		font-size: 13px;
		font-weight: 400;
	}
	.wrapper>>>.el-tabs__item.is-top{
		line-height: 50px;
		height: 50px;
		font-size: 18px;
	}
	.wrapper>>>.el-tabs__content{
		padding: 15px 25px;
	}

	.wrapper>>>.el-form-item{
		margin-bottom: 0px;
	}

	.wrapper>>>.el-input__inner{
		border: 1px solid #eaeff1;
		background: #fbfbfb;
		box-shadow: none;
		border-radius: 3px;
		height: 40px;
		font-size: 12px;
		padding: 4px 16px;
	}

	.wrapper>>>.el-input__inner:focus{
		border-color: #409EFF;
		outline: 0;
		box-shadow: 0 0 8px #409EFF;
	}

	.wrapper>>>.el-form-item.is-error .el-input__inner{
		border-color: #F56C6C;
		box-shadow: 0 0 8px #F56C6C;
	}

	.wrapper>>>.el-form-item__error{
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		position: absolute;
		top: 40px;
		right: 10px;
		line-height: 40px;
		padding-top: 0px;
		left: inherit;
	}

	.wrapper>>>.login-code-item .el-form-item__error {
		right: 130px;
	}

	.box-card{
		width:450px;
		height: 350px;
		margin: -100px auto 0 auto;
		border-radius: 0 0 5px 5px;
	}
	.title{
		font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
		font-size: 22px;
		text-align: center;
		margin: 20px auto 30px ;
	}
	.error{
		text-align: center;
		color: red;
		margin: -10px 0 10px 0;
	}

	.tab-panel{
		width: 100%;
		height: 100%;
	}

	.login-form{
		width: 100%;
		height: 280px;
	}

	.login-btn{
		width: 100%;
		margin-top: 40px;
	}

	.code-btn{
		width: 125px;
		font-size: 13px;
	}

	.el-button.is-disabled{
		color: #C0C4CC;
		cursor: not-allowed;
		background-image: none;
		background-color: #FFF;
		border-color: #EBEEF5;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ActivePassword.vue